import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { MENU_ITEMS } from "./constants/constants";
import AdditionalDetailsSidebar from "./Components/AdditionalDetailsSidebar";
import AdditionalDetailsContent from "./Components/AdditionalDetailsContent";
import Backdrop from "../../../UI/Backdrop/Backdrop";

const AndroidAdditionalDetails = () => {
  const [activeMenu, setActiveMenu] = useState(MENU_ITEMS[0]);
  const [menuItems, setMenuItems] = useState([]);

  const additionalDetails = useSelector((state) => state.android.additionalDetails);
  const additionalDetailsLoading = useSelector((state) => state.android.additionalDetailsLoading);

  useEffect(() => {
    const mappedMenuItems = MENU_ITEMS.map((menuItem) => ({
      ...menuItem,
      count:
        menuItem.countable && additionalDetails[menuItem.id]
          ? additionalDetails[menuItem.id].length
          : 0,
    }));
    setMenuItems(mappedMenuItems);
  }, [additionalDetails]);

  const selectMenuItemHandler = (menuItem) => {
    setActiveMenu(menuItem);
  };

  if (additionalDetailsLoading) {
    return (
      <div className="iocs border">
        <Backdrop show={additionalDetailsLoading} absolute={true} />
      </div>
    );
  }

  return (
    <div className="iocs border">
      <AdditionalDetailsSidebar
        menuItems={menuItems}
        activeMenu={activeMenu}
        onMenuItemSelect={selectMenuItemHandler}
      />
      <AdditionalDetailsContent activeMenu={activeMenu} additionalDetails={additionalDetails} />
    </div>
  );
};

export default AndroidAdditionalDetails;
